import * as CONFIG from './config';


exports.getMeeting = function (id) {
    // console.log("getMeeting==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/smeeting/meetingDetails' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getMeetingMinutes = function (id) {
    // console.log("getMeeting==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/smeeting/meetingMinutes' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.lookupMeetingList = function (id) {
    // console.log("getMeetingList==>", id);
    return new Promise((resolve, reject) => {
        //resolve('{"CommitteeList": [{"id": 10,"name": "Training Meeting - 1","status": "active"},{"id": 11,"name": "BAHRAIN NATIONAL INSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 12,"name": "BAHRAIN NATIONAL LIFE ASSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 13,"name": "BAHRAIN NATIONAL HOLDING BOARD OF DIRECTORS","status": "active"},{"id": 14,"name": "BNL Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 15,"name": "BNI Executive & Investment Committee (EIC)","status": "active"},{"id": 16,"name": "BNH Executive & Investment Committee (EIC)","status": "active"},{"id": 17,"name": "BNI Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 18,"name": "BNH Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 19,"name": "BNH Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 20,"name": "BNI Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 21,"name": "BNL Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 22,"name": "Alpha Meeting Attendee","status": "active"},{"id": 23,"name": "Alpha Meeting Committee Adminstrator","status": "active"},{"id": 24,"name": "Training team2","status": "active"},{"id": 25,"name": "chat team","status": "active"},{"id": 26,"name": "test1team","status": "active"},{"id": 27,"name": "Mobile Meeting","status": "active"}]}');
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/smeeting/meetingListForDD' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.getMeetingList = function (id) {
    // console.log("getMeetingList==>", id);
    return new Promise((resolve, reject) => {
        //resolve('{"CommitteeList": [{"id": 10,"name": "Training Meeting - 1","status": "active"},{"id": 11,"name": "BAHRAIN NATIONAL INSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 12,"name": "BAHRAIN NATIONAL LIFE ASSURANCE BOARD OF DIRECTORS ","status": "active"},{"id": 13,"name": "BAHRAIN NATIONAL HOLDING BOARD OF DIRECTORS","status": "active"},{"id": 14,"name": "BNL Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 15,"name": "BNI Executive & Investment Committee (EIC)","status": "active"},{"id": 16,"name": "BNH Executive & Investment Committee (EIC)","status": "active"},{"id": 17,"name": "BNI Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 18,"name": "BNH Audit, Compliance & Risk Committee (ACRC)","status": "active"},{"id": 19,"name": "BNH Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 20,"name": "BNI Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 21,"name": "BNL Nominations, Remunerations & Corporate Governance (NRCG) Committee","status": "active"},{"id": 22,"name": "Alpha Meeting Attendee","status": "active"},{"id": 23,"name": "Alpha Meeting Committee Adminstrator","status": "active"},{"id": 24,"name": "Training team2","status": "active"},{"id": 25,"name": "chat team","status": "active"},{"id": 26,"name": "test1team","status": "active"},{"id": 27,"name": "Mobile Meeting","status": "active"}]}');
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpGet('/smeeting/meetingListForAdmin' + param)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (err) {
                reject(err);
            });
    });
}

exports.addMeeting = function (objModel) {
    // console.log("addMeeting==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/smeeting/createMeeting', objModel)
            .then(function (response) {
                // console.log('addMeeting succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addMeeting err==>',err);
                reject(err);
            });
    });
}

exports.updateMeeting = function (objModel) {
    // console.log("updateMeeting==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/smeeting/updateMeeting', objModel)
            .then(function (response) {
                // console.log('updateMeeting succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateMeeting err==>',err);
                reject(err);
            });
    });
}

exports.updateMeetingStatus = function (id, status) {
    // console.log("updateMeetingStatus==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/smeeting/updateMeetingStatus/' + id + '/' + status)
            .then(function (response) {
                // console.log('updateMeetingStatus succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateMeetingStatus err==>',err);
                reject(err);
            });
    });
}

exports.deleteMeeting = function (id) {
    // console.log("deleteMeeting==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/smeeting/delete/' + id)
            .then(function (response) {
                // console.log('deleteMeeting succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('deleteMeeting err==>',err);
                reject(err);
            });
    });
}

exports.archiveMeeting = function (id) {
    // console.log("archiveMeeting==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/smeeting/archive/' + id)
            .then(function (response) {
                // console.log('archiveMeeting succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('archiveMeeting err==>',err);
                reject(err);
            });
    });
}

exports.sendMeetingNotification = function (notificationData) {
    // console.log("updateMeetingStatus==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/smeeting/MeetingNotification', notificationData)
            .then(function (response) {
                // console.log('updateMeeting succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateMeeting err==>',err);
                reject(err);
            });
    });
}


exports.addMeetingMinutesFile = function (objModel) {
    // console.log("addMeeting==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpPost('/smeeting/createMMFile/' + objModel.id, objModel)
            .then(function (response) {
                // console.log('addMeeting succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addMeeting err==>',err);
                reject(err);
            });
    });
}

exports.updateMeetingMinutesFile = function (id, objModel) {
    // console.log("updateFile==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpPostFile('/smeeting/updateExistingMMFile' + param, objModel)
            .then(function (response) {
                // console.log('updateFile succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateFile err==>',err);
                reject(err);
            });
    });
}

exports.deleteMeetingMinutesFile = function (id) {
    // console.log("updateFile==>", id);
    return new Promise((resolve, reject) => {
        let param = '';
        if (id && String(id).length > 0)
            param = '/' + id;
        return CONFIG.httpPost('/smeeting/deleteMMFile' + param)
            .then(function (response) {
                // console.log('updateFile succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('updateFile err==>',err);
                reject(err);
            });
    });
}

exports.sendMMNotifyEmail = function (id) {
    // console.log("addMeeting==>");
    return new Promise((resolve, reject) => {
        return CONFIG.httpGet('/smeeting/sendMMNotification/' + id)
            .then(function (response) {
                // console.log('addMeeting succ==>',response);
                resolve(response);
            })
            .catch(function (err) {
                // console.log('addMeeting err==>',err);
                reject(err);
            });
    });
}


// WEBPACK FOOTER //
// ./api/meetingdetails.js